import styled from 'styled-components';

export const Icon = styled.svg`
  fill: ${({ theme, fill }) => fill || theme.text.onSurface.strong};
`;
